/* Copyright (c) 2020 Pej AB. All rights reserved.
 * Created by Marcus Johansson on 2020-02-11. */

export class PejCardReader {
    public serialNumber: string;
    public vendor: string;
}
